import { useDispatch, useSelector } from 'react-redux';
import {
  PersistedUiState,
  setToggleAction,
} from 'src/store/slices/persistedUiSlice';

interface PersistedUiSliceState {
  persistedUi: PersistedUiState;
}

/* useState-shaped tuple for a boolean view toggle that lives in redux, so it
 * survives navigation and refresh. Drops straight in where a `useState<boolean>`
 * was, keeping the same [value, setValue] call sites. */
export type PersistedToggle = [boolean, (value: boolean) => void];

export const usePersistedToggle = (
  key: string,
  defaultValue: boolean = false
): PersistedToggle => {
  const dispatch = useDispatch();

  const value: boolean = useSelector(
    (state: PersistedUiSliceState) =>
      (state.persistedUi[key] as boolean) ?? defaultValue
  );

  const setValue = (nextValue: boolean): void => {
    dispatch(setToggleAction({ key, value: nextValue }));
  };

  return [value, setValue];
};
